const ROUTES = {
  "/": {
    "name": "HomePage4192a8edA2cd4722A59eD974e90caa4e",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPageB8b9bef935664bc69e4eBb11f70aa588",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/local-partnership": {
    "name": "LocalPartnershipPageD85e97da2c2944c8Aed80dedd24f88e8",
    "type": "HTML",
    "key": "local-partnership-page"
  },
  "/apply/*": {
    "name": "ApplicationPages0ed336a0Cebe4984Bdbf45bd5ca0af28",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/contact": {
    "name": "PublicContactPage9b1ae4c4E9ad4b19968c68e997e5436a",
    "type": "HTML",
    "key": "public-contact-page"
  },
  "/events/public": {
    "name": "PublicEventsPage77ee98ee38524f159c0308335faf554b",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/faq": {
    "name": "PublicFaqPageCea9d9ef69ee49718cabB2f3d0d42dca",
    "type": "HTML",
    "key": "public-faq-page"
  },
  "/join": {
    "name": "JoinUsPageF56cb81a742a45f186858f9f64d174d9",
    "type": "HTML",
    "key": "join-us-page"
  }
};

export default ROUTES;